module.exports = __webpack_public_path__ + "static/media/yoga.a53f8818.webp";